import React, { useState } from "react";
import PhotoGalleryModal from "./PhotoGalleryModal";
import { IMAGE_URL } from "../../../constants";

const PhotoGalleryTabInner = ({ activeTabContent }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = (image) => {
    setSelectedImage(image);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };
  return (
    <div
      class="row justify-content-center justify-content-md-between w-100 mx-auto"
      style={{ justifyContent: "space-between" }}
    >
      {activeTabContent && JSON.parse(activeTabContent.album_pics).length > 0
        ? JSON.parse(activeTabContent.album_pics).map((image, index) => {
            const isFirstImageTaller = index % 2 === 0;
            const firstMaxHeight = isFirstImageTaller ? "622px" : "276px";
            const secondMaxHeight = isFirstImageTaller ? "276px" : "622px";
            let firstImage = null;
            let secondImage = null;
            const incrementAmountForFirstImage = index + index;
            const incrementAmountForSecondImage = index + (index + 1);
            if (index >= JSON.parse(activeTabContent.album_pics).length / 2) {
              return;
            }
            if (index === 0) {
              firstImage = JSON.parse(activeTabContent.album_pics)[index];
              secondImage = JSON.parse(activeTabContent.album_pics)[index + 1];
            } else {
              firstImage = JSON.parse(activeTabContent.album_pics)[
                incrementAmountForFirstImage
              ];
              secondImage = JSON.parse(activeTabContent.album_pics)[
                incrementAmountForSecondImage
              ];
            }
            return (
              <div
                class={`col-lg-4 mb-4 mb-lg-0 px-0 d-flex flex-column flex-columns-gallery justify-content-between pb-2 w-100`}
              >
                {secondImage !== undefined ? (
                  <div
                    className="mb-3 w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    style={{
                      height: index % 2 === 0 ? "622px" : "276px",
                      cursor: "pointer",
                    }}
                    onClick={() => openModal(firstImage)}
                  >
                    <img
                      style={{ objectFit: "cover", width: "100%" }}
                      src={`${IMAGE_URL}AlbumImg/${firstImage}`}
                      class="w-100 h-100 shadow-1-strong rounded mb-4"
                      alt="Mountains in the Clouds"
                    />
                  </div>
                ) : (
                  ""
                )}

                {secondImage !== undefined ? (
                  <div
                    className="mb-3 w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    style={{
                      height: index % 2 === 0 ? "276px" : "622px",
                      cursor: "pointer",
                    }}
                    onClick={() => openModal(secondImage)}
                  >
                    <img
                      style={{ objectFit: "cover" }}
                      src={`${IMAGE_URL}AlbumImg/${secondImage}`}
                      class="w-100 h-100 shadow-1-strong rounded mb-4"
                      alt="Boat on Calm Water"
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })
        : ""}
      {/* Modal */}
      {selectedImage && (
        <PhotoGalleryModal
          selectedImage={selectedImage}
          closeModal={closeModal}
        ></PhotoGalleryModal>
      )}
    </div>
  );
};

export default PhotoGalleryTabInner;



// WEBPACK FOOTER //
// ./src/component/frontend/PhotoGalleryNew/PhotoGalleryTabInner.js